import React, { useState, useEffect } from "react";
import { useStateContext } from "../../../../../../Context/StateContext";

const PriceFilterBasedonID = ({ filter, id = 0, setfilter }) => {
  const { state, setMinRateById, setMaxRateById } = useStateContext();
  const { minRates = {}, maxRates = {} } = state || {};

  const [tempMinRate, setTempMinRate] = useState(minRates?.[id] ?? "");
  const [tempMaxRate, setTempMaxRate] = useState(maxRates?.[id] ?? "");
  const [error, setError] = useState("");

  // 🔁 Reset input fields whenever context min/max rates change for this id
  useEffect(() => {
    setTempMinRate(minRates?.[id] ?? "");
  }, [minRates?.[id]]);

  useEffect(() => {
    setTempMaxRate(maxRates?.[id] ?? "");
  }, [maxRates?.[id]]);

  const handleApply = async () => {
    const minRate = parseFloat(tempMinRate);
    const maxRate = parseFloat(tempMaxRate);

    if (isNaN(minRate) || isNaN(maxRate)) {
      setError("Please enter valid numbers.");
      return;
    }

    if (minRate < 0 || maxRate < 0) {
      setError("Rates cannot be negative.");
      return;
    }

    if (minRate <= 0) {
      setError("Min price cannot be zero or negative.");
      return;
    }

    if (maxRate <= 0) {
      setError("Max price cannot be zero.");
      return;
    }

    if (minRate > maxRate) {
      setError("Min rate cannot be greater than max rate.");
      return;
    }

    if (setfilter) {
      setfilter(false)
    }


    await Promise.all([
      setMinRateById(id, minRate),
      setMaxRateById(id, maxRate),
    ]);

    setError("");
  };

  return (
    <div className="filter-cont" key={id}>
      <h6>{filter.title}</h6>
      <div className="hourly-rate">
        <input
          type="text"
          className="form-control"
          placeholder="Min"
          value={tempMinRate}
          onChange={(e) => setTempMinRate(e.target.value)}
        />
        <input
          type="text"
          className="form-control"
          placeholder="Max"
          value={tempMaxRate}
          onChange={(e) => setTempMaxRate(e.target.value)}
        />
      </div>

      {error && <p style={{ color: "red" }}>{error}</p>}

      <button
        className="buttons background-button mt-3 w-100"
        onClick={handleApply}
      >
        Apply
      </button>
    </div>
  );
};

export default PriceFilterBasedonID;
